import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import ThemeProvider from '~/components/ThemeProvider.vue';
import { ThemeName } from '~/store/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ResponsiveDialog',
  props: {
    activator: null,
    attach: null,
    contentClass: { default: '' },
    closeButton: { type: Boolean, default: true },
    hideOverlay: { type: Boolean, default: false },
    maxWidth: { default: 600 },
    persistent: { type: Boolean, default: false },
    theme: { default: ThemeName.DARK },
    value: { type: Boolean, default: false }
  },
  emits: ["click:outside", "input", "keydown"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'click:outside', value: MouseEvent): void;
  (e: 'input', value: boolean): void;
  (e: 'keydown', value: KeyboardEvent): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as { activator?: string | Node, attach?: string | Node, contentClass: string, closeButton: boolean, hideOverlay: boolean, maxWidth: number | string, persistent: boolean, theme: ThemeName, value: boolean }





const { i18n } = useContext();

return { __sfc: true,props, emit, i18n, ThemeProvider, ThemeName }
}

})